<template>
	<div class="newtaskPage editFroms">
		<div class="bgBox doctorPage" v-loading="loading">
			<el-form label-width='85px' class="qcFrom" ref="newtaskPageFrom" :rules="rules" :model="rulesForm">
				<el-row>
					<el-col :span="16" class="setUpcol">
						<el-form-item label="角色名称" prop="RoleGuid">
							<el-select size="small" v-model="rulesForm.RoleGuid" filterable @change="rolesListChange" placeholder="请选择">
								<el-option label="全部" value=""></el-option>
								<el-option v-for="item in rolesList" :key="item.RoleGuid" :label="item.RoleName" :value="item.RoleGuid">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="selectSearch">
				<el-input size="small" placeholder="请输入菜单名称进行搜索" v-model="filterText"></el-input>
			</div>
			<el-tree :data="data" class="filter-tree marb25" node-key="KeyName" ref="tree" default-expand-all show-checkbox :props="defaultProps" :expand-on-click-node="false" :filter-node-method="filterNode">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span>{{ node.label }}</span>
				</span>
			</el-tree>
			<div class="dialog-footer footerSetUp">
				<el-button type="primary" class="bigBtn" @click="preservation">保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import axios from '@/js/api'
	export default {
		data() {
			return {
				rulesForm:{
					RoleGuid:''
				},
				previewFrom: '',
				filterText: '',
				rules:{
					RoleGuid:[{required:true,message:'请选择角色名称',trigger:'change'}],
					RoleName: [{
						required: true,
						message: '请输入路由路径',
						trigger: 'blur'
					}],
				},
				data:[],
				dataList:[],
				defaultProps: {
				  children: 'children',
				  label: 'label'
				}
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('admin', ['rolesList', 'listParameter']),
		},
		activated() {
			this.GetRoles({
				enable:'1'
			});
			this.$nextTick(()=>{
				if (this.rolesList != []) {
					this.rulesForm.RoleGuid = this.rolesList[0].RoleGuid
					this.rolesListChange(this.rolesList[0].RoleGuid);
				}
			})
			
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapActions('admin', ['GetRoles']),
			rolesListChange(value) {
				let _this = this;
				_this.setLoading(true);
				axios.ajaxGet('get', axios.Api.api.admin.GetRole2Modules,{
					roleGuid:value
				}).then(res => {
					if (res.data.StatusCode == 200) {
						this.data = res.data.Modules;
						let nameItem = [];
						function getName(vals) {
							vals.forEach((item, index) => {
								if (item.children) {
									getName(item.children)
								}
								if (item.Enable) {
									nameItem.push(item)
								}
							})
							return nameItem;
						}
						let items = getName(_this.data);
						_this.$nextTick(()=>{
							_this.$refs.tree.setCheckedNodes(items)
						})
						_this.setLoading(false);
					}
				})
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			preservation(){
				let _this = this;
				this.$refs.newtaskPageFrom.validate((valid) => {
					if (valid) {
						_this.setLoading(true);
						axios.ajaxPost('post', axios.Api.api.admin.role2module,{
							RoleGuid:_this.rulesForm.RoleGuid,
							KeyNames:this.$refs.tree.getCheckedKeys()
						}).then(res => {
							if (res.data.StatusCode == 200) {
								_this.$message.success('保存成功');
								_this.setLoading(false);
							}
						})
					} else {
						return false;
					}
				})
			}
		}
	}
</script>

<style scoped>
	.main_content>>>.el-tree-node__expand-icon {
		position: unset !important;
	}
	.selectSearch{
		margin-bottom: 20px;
	}
	.editFroms>>>.el-input__inner{
		border-radius: 100px;
	}
</style>
